export default __webpack_public_path__ + "static/banner-corporate-responsibility-b2184ade3a9f604ab8a637d2cf9ddb8b.jpg";